import Embedded from './Embedded';

const getBlockRenderFunc = (config: any, customBlockRenderer: any) => (block: any) => {
  if (typeof customBlockRenderer === 'function') {
    const renderedComponent = customBlockRenderer(block, config, config.getEditorState);
    if (renderedComponent) return renderedComponent;
  }
  if (block.getType() === 'atomic') {
    const contentState = config.getEditorState().getCurrentContent();
    const entityKey = block.getEntityAt(0);
    if (entityKey === null) {
      return undefined;
    }
    const entity = contentState.getEntity(entityKey);
  if (entity && entity.type === 'EMBEDDED_LINK') {
      return {
        component: Embedded,
        editable: false,
      };
    }
  }
  return undefined;
};

export default getBlockRenderFunc;
